import { Box, Flex } from '@mantine/core';
import {
  IconArrowRight,
  IconBrandDatabricks,
  IconCheck,
  IconUserFilled,
} from '@tabler/icons-react';
import classes from './FinalizeReviewAnimation.module.css';

const COLLAPSED_WIDTH =
  70 + // Tile width
  16; // Leading and trailing padding

const EXPANDED_WIDTH =
  140 + // Two tiles
  24 + // Arrow
  24 + // 12px inner padding * 2
  16; // Outer padding

export default function FinalizeReviewAnimation({ collapsed = false }: { collapsed?: boolean }) {
  return (
    <Flex h={64} justify="center">
      <Flex
        h={64}
        w={collapsed ? COLLAPSED_WIDTH : '100%'}
        bg={collapsed ? 'brand.6' : 'gray.2'}
        align="center"
        justify="center"
        style={{ borderRadius: 32 }}
        className={classes.background}
      >
        <Flex
          align="center"
          justify="center"
          className={classes.innerContainer}
          style={{ width: collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH }}
        >
          <Tile
            icon={<IconBrandDatabricks size={24} color="black" />}
            className={classes.leftTile}
          />
          <Flex className={classes.arrow} mx="xs" w={24} align="center" justify="center">
            <IconArrowRight
              size={28}
              color="var(--mantine-color-gray-3)"
              strokeWidth={2}
              style={{ opacity: collapsed ? 0 : 1 }}
            />
          </Flex>
          <Tile
            className={classes.rightTile}
            icon={
              <Box style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                <Flex
                  align="center"
                  justify="center"
                  style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
                >
                  <IconUserFilled
                    className={classes.userIcon}
                    size={24}
                    color="black"
                    style={{ opacity: collapsed ? 0 : 1 }}
                  />
                </Flex>
                <Flex
                  align="center"
                  justify="center"
                  style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
                >
                  <IconCheck
                    className={classes.checkIcon}
                    size={24}
                    color="var(--mantine-color-brand-6)"
                    style={{ opacity: collapsed ? 1 : 0 }}
                  />
                </Flex>
              </Box>
            }
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

type IconProps = {
  icon: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};
function Tile({ icon, className, style }: IconProps) {
  return (
    <Flex
      className={className}
      w={70}
      h={48}
      bg="white"
      style={{ borderRadius: 24, ...(style ?? {}) }}
      justify="center"
      align="center"
    >
      {icon}
    </Flex>
  );
}
